import { runFunction } from "../../http";

export const joinGroup = async (groupId: string): Promise<void> =>
  await runFunction("joinGroup", { groupId: groupId }, { requireUser: true });
